import React from 'react';
import classNames from 'classnames';
import Icon from '~/app/common/Icon';
import classes from './style.module.scss';
import useTranslation from "~/app/hooks/useTranslation";
import LinkWrapper from "~/app/common/LinkWrapper";
import { TRAINING_ROUTES } from '~/training/Router';
import { route } from '~/app/helpers/route';
import { Training, TRAINING_STATUS } from '~/training/types';
import { useStoreState } from '~/store';

export interface ListItemProps {
    item: Training
    listClassName?: string
}

export type ListItemComponent = React.FC<ListItemProps>

const ListItem: ListItemComponent = ({item, listClassName}) => {

    const { t } = useTranslation("training");
    const netWorkStatus = useStoreState(state => state.app.offline.status);

    const listItemContent = (
        <>
            <div className={classes['info']}>
                <div className={classes['title']}>{item.title}</div>
                <div className={classes['details']}>
                    <span>{item.trainingDate}</span>
                    {item.status !== undefined && item.status !== null && item.status !== TRAINING_STATUS.NOTAPPLICABLE && (
                        <span className={`${classes['status']} ${classes[item.status]}`}>{t(`status.${item.status}`)}</span>
                    )}
                </div>
            </div>
            {netWorkStatus === 0 && (
                <div className={classNames(classes['right-icon-wrap'])}>
                    <Icon name="keyboard_arrow_right"/>
                </div>
            )}
        </>
    );

    return netWorkStatus === 0 ? (
        <LinkWrapper
            className={`${classes['list-item']} ${listClassName && classes[listClassName]}`}
            to={route(TRAINING_ROUTES.details, {id: item.id})}
        >
            {listItemContent}
        </LinkWrapper>
    ) : (
        <div className={`${classes['list-item']} ${listClassName && classes[listClassName]}`}>
            {listItemContent}
        </div>
    );
};

export default ListItem
